/**
 * Created by m.igrachev on 6/30/2017.
 */
import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import ArrayUtils from "@tinqin/tinqin-utils/src/array";
import documentedProps from "./documentation/ControlMessagesDocumentedProps";

import("./ControlMessages.less");

export default class ControlMessages extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            closedGroups: []
        };

        this.onCloseGroup = this.onCloseGroup.bind(this);
        this.onClose = this.onClose.bind(this);
        this.onAccept = this.onAccept.bind(this);
    }

    onClose() {
        if (this.props.onClose) {
            this.props.onClose(this.state);
        }
    }

    onAccept() {
        if (this.props.onAccept) {
            this.props.onAccept(this.state);
        }
    }

    componentWillReceiveProps(newProps) {
        if (ArrayUtils.shallowEquals(this.state.closedGroups, newProps.closedGroups)) {
            this.setState({
                closedGroups: newProps.closedGroups
            });
        }
    }

    onCloseGroup(state, props) {
        let groupType = props.groupType;
        let closedGroups = this.state.closedGroups;

        this.setState(
            {
                closedGroups: closedGroups.concat([groupType])
            },
            () => {
                let groups = this.getGroups();
                if (groups.length === 0) {
                    this.onClose();
                }
            }
        );
    }

    getGroups() {
        return React.Children.map(this.props.children, group => {
            if (!React.isValidElement(group)) return;

            const displayName = group.type.displayName || group.type.name;
            if (displayName.includes("ControlMessageGroup")) {
                if (!this.state.closedGroups.includes(group.props.groupType)) {
                    return group;
                }
            }
        });
    }

    orderGroups() {
        let result = {};
        let groups = this.getGroups();

        groups.forEach(group => {
            let isClosable = group.props.closable;
            let groupType = group.props.groupType || "error";
            result[groupType] = React.cloneElement(group, {
                closable: isClosable,
                onClose: this.onCloseGroup,
                bigIcon: this.props.bigIcons,
                theme: this.props.theme
            });
        });

        return result;
    }

    render() {
        let orderedGroups = this.orderGroups();
        let className = this.props.extraClasses || "";
        let messagesWrapperClass;
        let closeGroupButton;
        if (this.props.visualizationLayer === "onTop") {
            messagesWrapperClass = "tq-float-alert-container";
        }
        if (this.props.visualizationLayer === "modal") {
            className += " tq-modal tq-modal-visible";
            let modalSize = this.props.modalSize || "m";
            messagesWrapperClass = "tq-cm-container tq-cm-" + modalSize;
            if (!this.props.onAccept && Object.keys(orderedGroups).length > 1) {
                closeGroupButton = true;
            }
        }
        let acceptButtonClass = "tq-button tq-offset-right-s ";
        if (this.props.acceptButtonExtraClasses) {
            acceptButtonClass += this.props.acceptButtonExtraClasses;
        }
        let closeButtonClass = "tq-button ";
        if (this.props.closeButtonExtraClasses) {
            closeButtonClass += this.props.closeButtonExtraClasses;
        }

        let controlMessage = (
            <div className={className} data-tq-id={this.props.dataTqId}>
                {this.props.visualizationLayer === "modal" && <div className="tq-cm-overlay" />}
                <div className={messagesWrapperClass}>
                    {closeGroupButton && (
                        <div className="tq-button-container tq-offset-bottom">
                            <button className="tq-button tq-size-s" onClick={this.props.onClose}>
                                <i className="tq-icon-close" />
                            </button>
                        </div>
                    )}
                    {orderedGroups.error}
                    {orderedGroups.success}
                    {orderedGroups.warning}
                    {orderedGroups.info}
                    {orderedGroups.neutral}
                    {this.props.visualizationLayer === "modal" && this.props.onAccept && (
                        <div className="tq-button-container tq-offset-bottom">
                            <button className={acceptButtonClass} onClick={this.onAccept}>
                                <span className="tq-text-node">{this.props.acceptLabel}</span>
                            </button>
                            {this.props.closeLabel && (
                                <button className={closeButtonClass} onClick={this.onClose}>
                                    <span className="tq-text-node">{this.props.closeLabel}</span>
                                </button>
                            )}
                        </div>
                    )}
                </div>
            </div>
        );

        if (
            this.props.visualizationLayer === "onTop" ||
            this.props.visualizationLayer === "modal"
        ) {
            return ReactDOM.createPortal(controlMessage, document.body);
        } else return controlMessage;
    }
}

ControlMessages.displayName = "ControlMessages";

ControlMessages.propTypes = {
    extraClasses: PropTypes.string,
    theme: PropTypes.oneOf(["light", "dark", "accent"]),
    visualizationLayer: PropTypes.oneOf(["normal", "onTop", "modal"]),
    bigIcons: PropTypes.bool,
    modalSize: PropTypes.oneOf(["s", "m", "l"]),
    acceptLabel: PropTypes.string,
    closeLabel: PropTypes.string,
    onClose: PropTypes.func,
    onAccept: PropTypes.func,
    dataTqId: PropTypes.string,
    acceptButtonExtraClasses: PropTypes.string,
    closeButtonExtraClasses: PropTypes.string
};

ControlMessages.documentedProps = documentedProps;
